import { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { EyeMark } from "./Logo";

const BookCover = ({ className = "" }) => {
  const ref = useRef(null);
  const mx = useMotionValue(0.5);
  const my = useMotionValue(0.5);
  const rotateX = useSpring(useTransform(my, [0, 1], [10, -10]), { stiffness: 120, damping: 16 });
  const rotateY = useSpring(useTransform(mx, [0, 1], [-12, 12]), { stiffness: 120, damping: 16 });

  const onMove = (e) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    mx.set((e.clientX - r.left) / r.width);
    my.set((e.clientY - r.top) / r.height);
  };

  return (
    <div style={{ perspective: 1200 }} className={className}>
      <motion.div
        ref={ref}
        data-testid="book-cover-3d"
        onMouseMove={onMove}
        onMouseLeave={() => {
          mx.set(0.5);
          my.set(0.5);
        }}
        style={{ rotateX, rotateY, transformStyle: "preserve-3d" }}
        className="relative aspect-[3/4] w-full max-w-sm rounded-md bg-gradient-to-br from-[#06333E] via-[#084049] to-[#052730] border border-[#D4AF37]/25 gold-glow overflow-hidden"
      >
        <div
          className="absolute inset-0 opacity-[0.08]"
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
          }}
        />
        <div className="absolute inset-0 flex flex-col items-center justify-between py-8 px-6 text-center">
          <p className="font-mono-alt text-[9px] sm:text-[10px] uppercase tracking-[0.35em] text-[#D4AF37]">
            From the Archives of the Gg Elves
          </p>
          <div className="relative flex items-center justify-center">
            <div className="absolute w-56 h-56 rounded-full border border-[#D4AF37]/20 animate-spin-slower" style={{ borderStyle: "dashed" }} />
            <div className="absolute w-44 h-44 rounded-full border border-[#D4AF37]/30" />
            <div className="absolute w-32 h-32 rounded-full border border-[#D4AF37]/40" />
            <EyeMark className="w-24 h-24" />
          </div>
          <div>
            <h3 className="font-display text-2xl sm:text-3xl font-bold text-[#F8FAFC] leading-tight">
              The End of<br />the Obvious
            </h3>
            <p className="mt-3 font-mono-alt text-[9px] sm:text-[10px] tracking-[0.25em] text-[#D4AF37]">
              SIGNALS · PERCEPTION · THE MENU · THE LONG CLOCK
            </p>
          </div>
        </div>
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: "linear-gradient(115deg, transparent 30%, rgba(255,255,255,0.06) 45%, transparent 60%)" }}
        />
        <div className="absolute left-0 top-0 bottom-0 w-[6px] bg-gradient-to-r from-black/60 to-transparent" />
      </motion.div>
    </div>
  );
};

export default BookCover;
